import { createReducer } from '@reduxjs/toolkit'
import { types } from '../../actions/reports/projects_report'

const initialState = {
  availableFilters: [],
  selectedFilters: [],
  savedFilters: []
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(types.SET_AVAILABLE_FILTERS, (state, action) => {
      state.availableFilters = action.filters
    })
    .addCase(types.SET_SELECTED_FILTERS, (state, action) => {
      state.selectedFilters = action.filters
    })
    .addCase(types.LOAD_AVAILABLE_FILTERS, (state, action) => {
      state.availableFilters = action.data.filters
    })
    .addCase(types.SET_SAVED_FILTERS, (state, action) => {
      state.savedFilters = action.filters
    })
    .addCase(types.UPDATE_USER_FILTERS, (state, action) => {
      state.savedFilters = action.data.filters
    })
})
